// apps/app/src/features/chat/state/useMention.ts
import type { Profile } from '@hvf/contracts'
import { debounce } from '@solid-primitives/scheduled'
import { createQuery } from '@tanstack/solid-query'
import { createSignal } from 'solid-js'
import { getProfiles } from './resources/getProfiles'


export function useMention() {
  const [searchTerm, setSearchTerm] = createSignal('')
  const [activeMentions, setActiveMentions] = createSignal<Profile[]>([])

  const profilesQuery = createQuery(() => ({
    queryKey: ['profiles', searchTerm()],
    queryFn: () => getProfiles(searchTerm()),
    enabled: searchTerm().length > 0, // Don't fetch if search is empty
    staleTime: 1000 * 60 * 5, // Cache profile searches for 5 minutes
  }))

  return {
    searchTerm,
    setSearchTerm: debounce(setSearchTerm, 300),
    profilesQuery,
    activeMentions,
    setActiveMentions,
  }
}
